import React, { useCallback, useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical } from '@fortawesome/pro-light-svg-icons/faEllipsisVertical';
import { TypedMemo } from '../../common/types';
import { SMLLink } from '../../music24/components/SMLLink/SMLLink';
import { useVisibleNavigationItems } from '../../music24/navigation/hooks/useVisibleNavigationItems';
import { smlNavigationChromeMessages } from '../../music24/navigation/smlNavigationMessages';

/**
 * The mobile "…" menu of the old top bar. It shows only on signed-in pages outside `SMLContainer`
 * (the SmartLink editors), which have no `MobileNav`; it lists every destination from the one
 * navigation list, so the editors keep a way to every section.
 */
const SmartLinksNavbarMenuComponent: React.FC = () => {
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(false);
  const toggle = useCallback(() => setIsOpen((current) => !current), []);
  const navigationItems = useVisibleNavigationItems();

  return (
    <Dropdown isOpen={isOpen} toggle={toggle} nav inNavbar className="d-md-none">
      <DropdownToggle
        tag="button"
        className="btn btn-link p-2 ps-4 pe-3 border-0"
        aria-label={intl.formatMessage(smlNavigationChromeMessages.more)}
      >
        <FontAwesomeIcon icon={faEllipsisVertical} size="lg" />
      </DropdownToggle>
      <DropdownMenu end>
        {navigationItems.map((item) => (
          <DropdownItem key={item.id} tag="div" className="p-0">
            <SMLLink to={item.route} className="d-flex align-items-center px-3 py-2 text-decoration-none">
              <FontAwesomeIcon icon={item.icon} className="me-2" fixedWidth />
              {intl.formatMessage(item.label)}
            </SMLLink>
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export const SmartLinksNavbarMenu = TypedMemo(SmartLinksNavbarMenuComponent);
